<template>
  <div class="flex-column pr-2 animate__animated animate__slideInDown">
    <div class="fav-item" v-on:mouseover="clear()">
      <span
        v-if="removeButtonVisibility"
        class="remove-fav d-none"
        @click="removeFav(item.symbol)"
      >
        <i class="remove-icon sr sr-close"></i>
      </span>
      <div
        class="topbar-buttons"
        :id="`fav-item-${item.symbol}`"
        @click="openBrand"
        :class="{
          tag: !isSelectedSymbol(),
          'tag selected-brand': isSelectedSymbol(),
        }"
      >
        <div class="symbol_name">
          {{ toSymbolName(item.symbol) }} <span class="exchange-code">/ {{ item.exchange_server_code ?? '--' }}</span>
          <span
            v-if="unread > 0 && !isSelectedSymbol()"
            class="unread-count animate__animated animate__infinite animate__flash"
            >{{ getUnreadCount() }}</span
          >
          <p class="price">
            {{
              item.stype === 2 && item.bond_type === 100
                    ? item.closing_price * 1000
                    : item.closing_price | currency('', '')
            }}
          </p>
        </div>
        <div class="company_name">
          <span :class="getClass(item.previous_day_ratio_percent)">
            {{
              (item.previous_day_ratio_percent >= 0 ? "+" : "") +
              parseFloat(item.previous_day_ratio_percent).toFixed(2)
            }}%</span
          >
          <span :class="getClass(item.previous_day_ratio_value)">
            {{
              (item.previous_day_ratio_value >= 0 ? "+" : "") +
              parseFloat(item.previous_day_ratio_value).toFixed(2)
            }}₮</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script charset="utf-8">
import api from "../api/stoTrade";
import { mapActions, mapState } from "vuex";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    brand: {
      type: Object,
      required: true,
    },
    removeFav: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      // unread: Math.floor(Math.random() * 100) + 1,
      unread: 0,
      subscription: null,
    };
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  mounted() {
    this.unread = this.getUnread();
  },
  computed: {
    ...mapState("cent", ["instance", "connected"]),
    removeButtonVisibility() {
      //return this.favoriteBrands && this.favoriteBrands.length && this.isSto;
      return true;
    },
  },
  methods: {
    ...mapActions("brand", ["setBrand"]),
    isSelectedSymbol() {
      return this.item.symbol === this.brand.symbol;
    },
    getUnreadCount() {
      return this.unread > 50 ? "50+" : this.unread;
    },
    toSymbolName(symbol) {
      if (!symbol) return;
      return !symbol.split("").includes("-")
        ? symbol
        : symbol
            .split("")
            .splice(
              0,
              symbol.split("").findIndex((x) => x === "-")
            )
            .join("")
            .toString();
    },
    getClass(value) {
      const negative = value < 0;
      return {
        "text-red": negative,
        "text-green": !negative,
      };
    },
    openBrand() {
      document.getElementById(`fav-item-${this.item.symbol}`).blur();
      this.selectedBrand = this.item;
      this.setBrand(this.item);
      this.unsubscribe();
      this.$forceUpdate();
    },
    increase() {
      window.localStorage.setItem("_unread_" + this.item.symbol, ++this.unread);
    },
    clear() {
      this.unread = 0;
      window.localStorage.setItem("_unread_" + this.item.symbol, 0);
    },
    getUnread() {
      return window.localStorage.getItem("_unread_" + this.item.symbol) || 0;
    },
    silentSubscribe() {
      this.unsubscribe();
      if (!this.isSelectedSymbol() && this.connected) {
        const symbol = this.item.symbol;
        this.subscription = this.instance.subscribe(`stock:${symbol}`, (msg) =>
          this.increase()
        );
        // this.subscription.on('subscribe', (ctx) => console.log('sub', ctx))
      }
    },
    unsubscribe() {
      if (this.subscription) this.subscription.unsubscribe();
    },
  },
  watch: {
    //connected: {
    //  handler: 'silentSubscribe',
    //},
  },
};
</script>
